module.exports = __webpack_public_path__ + "img/logo-icon-white.2de90288.png";